import { render, staticRenderFns } from "./UserPage.vue?vue&type=template&id=f086458e"
import script from "./UserPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports